<div class="header-bar">
  <h1>Comms Templates</h1>
</div>

<p-tabView (onChange)="changeTab($event)" class="hideTabPanel">
  <p-tabPanel header="Templates"></p-tabPanel>
  <p-tabPanel header="Events"></p-tabPanel>
  <p-tabPanel header="History"></p-tabPanel>
</p-tabView>
<div *ngIf="tab == 0" class="content-container">
  <comms-template></comms-template>
</div>
<div *ngIf="tab == 1" class="content-container">
  <comms-event [commsEvents]="commsEvents"></comms-event>
</div>
<div *ngIf="tab == 2" class="content-container">
  <comms-history></comms-history>
</div>
